<template>
	<div>
		<div :class="'text-c mt-10 ' + 用户设置参数.编辑表单号码尺寸">
			<span class="c-orange ziti-b mr-10">车辆编号：{{ cheliangbianhao }}</span>
		</div>

		<el-form :model="编辑表单" ref="编辑表单" :rules="编辑表单验证" :size="用户设置参数.编辑表单尺寸" label-width="auto">
			<mianban header="车辆信息" yangshi="panel-primary" class="ma-10">
				<div>
					<el-row>
						<el-col :span="6">
							<el-form-item label="车牌号码" prop="车牌号码" required>
								<el-input v-model.trim="编辑表单.车牌号码" placeholder="请输入车牌号码"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="名称" prop="名称" required>
								<el-input v-model="编辑表单.名称" placeholder="请输入名称"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="车型" prop="车型" required>
								<el-select v-model="编辑表单.车型" placeholder="车型" style="width: 100%;">
									<el-option label="小车" value="小车"></el-option>
									<el-option label="大车" value="大车"></el-option>
									<el-option label="中型车" value="中型车"></el-option>
									<el-option label="新能源大车" value="新能源大车"></el-option>
									<el-option label="新能源小车" value="新能源小车"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="车辆类型" prop="车辆类型" required>
								<el-select v-model="编辑表单.车辆类型" placeholder="车辆类型" style="width: 100%;">
									<el-option label="小型普通客车" value="小型普通客车"></el-option>
									<el-option label="小型轿车" value="小型轿车"></el-option>
									<el-option label="大型普通客车" value="大型普通客车"></el-option>
									<el-option label="中型普通客车" value="中型普通客车"></el-option>
									<el-option label="轿车" value="轿车"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="6">
							<el-form-item label="使用性质" prop="使用性质" required>
								<el-select v-model="编辑表单.使用性质" placeholder="使用性质" style="width: 100%;">
									<el-option label="非营运" value="非营运"></el-option>
									<el-option label="营转非" value="营转非"></el-option>
									<el-option label="租赁" value="租赁"></el-option>
									<el-option label="预约出租客运" value="预约出租客运"></el-option>
									<el-option label="预约出租转非" value="预约出租转非"></el-option>
									<el-option label="旅游客运" value="旅游客运"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="车辆所有人" prop="车辆所有人" required>
								<el-input v-model="编辑表单.车辆所有人" placeholder="请输入车辆所有人"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="车辆分类" prop="车辆分类" required>
								<el-select v-model="编辑表单.车辆分类" placeholder="请选择车辆分类" style="width: 100%;">
									<el-option v-for="v in 车辆分类2列表" :key="'车辆分类'+v" :label="v" :value="v"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="品牌型号" prop="品牌型号" required>
								<el-input v-model="编辑表单.品牌型号" placeholder="请输入品牌型号"></el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="6">
							<el-form-item label="发动机排量" prop="发动机排量" required>
								<el-input v-model="编辑表单.发动机排量" placeholder="单位ml无需填写"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="整备质量" prop="整备质量" required>
								<el-input v-model="编辑表单.整备质量" placeholder="单位kg无需填写"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="总质量" prop="总质量" required>
								<el-input v-model="编辑表单.总质量" placeholder="单位kg无需填写"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="核定载人数" prop="核定载人数" required>
								<el-input v-model="编辑表单.核定载人数" placeholder="请输入核定载人数"></el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="6">
							<el-form-item label="车身颜色" prop="车身颜色" required>
								<el-input v-model="编辑表单.车身颜色" placeholder="直接填颜色，不要加色字，例如：灰。有多种颜色加/，例如：蓝/黄/红">
								</el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="发动机号码" prop="发动机号码" required>
								<el-input v-model="编辑表单.发动机号码" placeholder="请输入发动机号码"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="车辆识别代号" prop="车辆识别代号" required>
								<el-input v-model="编辑表单.车辆识别代号" placeholder="请输入车辆识别代号"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="登记证书号" prop="登记证书号" required>
								<el-input v-model="编辑表单.登记证书号" placeholder="请输入登记证书号"></el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="6">
							<el-form-item label="行驶证注册日期" prop="行驶证注册日期" required>
								<el-date-picker v-model="编辑表单.行驶证注册日期" type="date" value-format="yyyy-MM-dd"
									format="yyyy-MM-dd" placeholder="行驶证注册日期" style="width: 100%;"></el-date-picker>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="行驶证发证日期" prop="行驶证发证日期" required>
								<el-date-picker v-model="编辑表单.行驶证发证日期" type="date" value-format="yyyy-MM-dd"
									format="yyyy-MM-dd" placeholder="行驶证发证日期" style="width: 100%;"></el-date-picker>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="类型" prop="类型" required>
								<el-select v-model="编辑表单.类型" placeholder="类型" style="width: 100%;">
									<el-option label="大陆" value="大陆"></el-option>
									<el-option label="港车" value="港车"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="类别" prop="类别" required>
								<el-select v-model="编辑表单.类别" placeholder="请选择类别" style="width: 100%;">
									<el-option v-for="v in 车辆类别列表" :key="'类别'+v" :label="v" :value="v"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="6">
							<el-form-item label="使用单位" prop="单位" required>
								<el-input v-model="编辑表单.单位" placeholder="请输入单位"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="保留车牌" prop="保留车牌" required>
								<el-select v-model="编辑表单.保留车牌" placeholder="保留车牌" style="width: 100%;">
									<el-option label="否" value="否"></el-option>
									<el-option label="是" value="是"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="驾驶员">
								<el-input v-model="编辑表单.驾驶员" placeholder="请输入驾驶员"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="驾驶员手机">
								<el-input v-model="编辑表单.驾驶员手机" placeholder="请输入驾驶员手机"></el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="6">
							<el-form-item label="轮胎规格">
								<el-input v-model="编辑表单.轮胎规格" placeholder="请输入轮胎规格"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="卖出日期">
								<el-date-picker v-model="编辑表单.卖出日期" type="date" value-format="yyyy-MM-dd"
									format="yyyy-MM-dd" placeholder="卖出日期" style="width: 100%;"></el-date-picker>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="卖出价格">
								<el-input v-model="编辑表单.卖出价格" placeholder="请输入卖出价格"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="驾驶证类型">
								<el-input v-model="编辑表单.驾驶证类型" placeholder="请输入驾驶证类型"></el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="24">
							<el-form-item label="备注">
								<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 10 }" v-model="编辑表单.备注"
									placeholder="请输入备注">
								</el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="24">
							<el-form-item label="旧车牌">
								<el-input v-model="编辑表单.旧车牌" placeholder="请输入旧车牌,多个用英文逗号分隔,不建议太多个"></el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="6">
							<el-form-item label="交强险开始日期">
								<el-date-picker v-model="编辑表单.交强险开始日期" type="date" value-format="yyyy-MM-dd"
									format="yyyy-MM-dd" placeholder="交强险开始日期" style="width: 100%;"></el-date-picker>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="交强险结束日期">
								<el-date-picker v-model="编辑表单.交强险结束日期" type="date" value-format="yyyy-MM-dd"
									format="yyyy-MM-dd" placeholder="交强险结束日期" style="width: 100%;"></el-date-picker>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="商业险开始日期">
								<el-date-picker v-model="编辑表单.商业险开始日期" type="date" value-format="yyyy-MM-dd"
									format="yyyy-MM-dd" placeholder="商业险开始日期" style="width: 100%;"></el-date-picker>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="商业险结束日期">
								<el-date-picker v-model="编辑表单.商业险结束日期" type="date" value-format="yyyy-MM-dd"
									format="yyyy-MM-dd" placeholder="商业险结束日期" style="width: 100%;"></el-date-picker>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="6">
							<el-form-item label="购买价格" prop="购买价格" required>
								<el-input-number style="width: 100%;" v-model="编辑表单.购买价格" :precision="2" :step="100"
									:min="0.00" :controls="false" :disabled="购买价格权限!='车辆管理-购买价格'"></el-input-number>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="购买日期">
								<el-date-picker v-model="编辑表单.购买日期" type="date" value-format="yyyy-MM-dd"
									format="yyyy-MM-dd" placeholder="购买日期" style="width: 100%;"></el-date-picker>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="使用年限">
								<el-input v-model="编辑表单.使用年限" placeholder="请输入使用年限"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="年检时间">
								<el-date-picker v-model="编辑表单.年检时间" type="date" value-format="yyyy-MM-dd"
									format="yyyy-MM-dd" placeholder="年检时间" style="width: 100%;"></el-date-picker>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="6">
							<el-form-item label="承运险开始日期">
								<el-date-picker v-model="编辑表单.承运险开始日期" type="date" value-format="yyyy-MM-dd"
									format="yyyy-MM-dd" placeholder="承运险开始日期" style="width: 100%;">
								</el-date-picker>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="承运险结束日期">
								<el-date-picker v-model="编辑表单.承运险结束日期" type="date" value-format="yyyy-MM-dd"
									format="yyyy-MM-dd" placeholder="承运险结束日期" style="width: 100%;">
								</el-date-picker>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="油卡编号">
								<el-select v-model="编辑表单.油卡编号" filterable placeholder="请选择" style="width: 100%;">
									<el-option label="不绑定" value=""></el-option>
									<el-option v-for="v in 油卡列表" :key="v" :label="v" :value="v">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="送车时间">
								<el-date-picker v-model="编辑表单.送车时间" type="date" value-format="yyyy-MM-dd"
									format="yyyy-MM-dd" placeholder="送车时间" style="width: 100%;">
								</el-date-picker>
							</el-form-item>
						</el-col>
					</el-row>


				</div>

			</mianban>

			<mianban header="整备费" yangshi="panel-secondary" class="ma-10">
				<div>
					<table class="table table-border table-bordered table-striped table-hover c-333 f-14">
						<thead class="text-c">
							<tr>
								<th>日期/合计栏</th>
								<th>加油费</th>
								<th>维修费</th>
								<th>配件费</th>
								<th>快递费</th>
								<th>过户费</th>
								<th>免检费</th>
								<th>年审费</th>
								<th>拖车费</th>
								<th>车辆罚款</th>
								<th>指标租赁费</th>
								<th>洗车费</th>
								<th>代驾费</th>
								<th>购置税</th>
								<th>交强险</th>
								<th>商业险</th>
								<th>迁出费</th>
								<th>ETC费</th>
								<th>其它费</th>
								<th>合计</th>
							</tr>
						</thead>
						<tbody class="text-c">
							<tr v-for="(v,k) in 整备费" :key="'整备费'+k">
								<th>{{v.日期}}</th>
								<th>{{v.加油费}}</th>
								<th>{{v.维修费}}</th>
								<th>{{v.配件费}}</th>
								<th>{{v.快递费}}</th>
								<th>{{v.过户费}}</th>
								<th>{{v.免检费}}</th>
								<th>{{v.年审费}}</th>
								<th>{{v.拖车费}}</th>
								<th>{{v.车辆罚款}}</th>
								<th>{{v.指标租赁费}}</th>
								<th>{{v.洗车费}}</th>
								<th>{{v.代驾费}}</th>
								<th>{{v.购置税}}</th>
								<th>{{v.交强险}}</th>
								<th>{{v.商业险}}</th>
								<th>{{v.迁出费}}</th>
								<th>{{v.ETC费}}</th>
								<th>{{v.其它费}}</th>
								<th>{{v.合计}}</th>
							</tr>
							<tr v-if="整备费统计.合计">
								<th>合计栏</th>
								<th>{{整备费统计.加油费}}</th>
								<th>{{整备费统计.维修费}}</th>
								<th>{{整备费统计.配件费}}</th>
								<th>{{整备费统计.快递费}}</th>
								<th>{{整备费统计.过户费}}</th>
								<th>{{整备费统计.免检费}}</th>
								<th>{{整备费统计.年审费}}</th>
								<th>{{整备费统计.拖车费}}</th>
								<th>{{整备费统计.车辆罚款}}</th>
								<th>{{整备费统计.指标租赁费}}</th>
								<th>{{整备费统计.洗车费}}</th>
								<th>{{整备费统计.代驾费}}</th>
								<th>{{整备费统计.购置税}}</th>
								<th>{{整备费统计.交强险}}</th>
								<th>{{整备费统计.商业险}}</th>
								<th>{{整备费统计.迁出费}}</th>
								<th>{{整备费统计.ETC费}}</th>
								<th>{{整备费统计.其它费}}</th>
								<th>{{整备费统计.合计}}</th>
							</tr>
						</tbody>
					</table>
				</div>
			</mianban>

			<mianban header="附件上传" yangshi="panel-success" class="ma-10">
				<div style="whith:100%">
					<el-upload ref="附件上传" class="upload-demo" :file-list="编辑表单.附件网址" :on-success="uploadsuccess"
						:on-remove="uploadremove" :on-preview="onfile" :headers="gg.headers" :on-error="uploaderror"
						drag :action="gg.fuwuqi + '/gg/shangchuan/wenjian'" list-type="text" multiple>
						<i class="el-icon-upload"></i>
						<div class="el-upload__text">
							将文件拖到此处，或
							<em>点击上传</em>
						</div>
					</el-upload>

				</div>
			</mianban>

			<div class="text-c mt-20 mb-10">
				<el-button @click="关闭编辑页面()" :class="用户设置参数.编辑表单按钮尺寸" size="mini" type="danger">关闭编辑页面</el-button>
				<el-button @click="保存()" :class="用户设置参数.编辑表单按钮尺寸" size="mini" type="primary">保存</el-button>
			</div>


		</el-form>
	</div>
</template>

<script>
	export default {
		name: 'clxx-edit',
		props: {
			cheliangbianhao: Number
		},
		data() {
			return {
				用户设置参数: JSON.parse(localStorage.getItem('用户设置参数')),
				编辑表单: {
					车辆编号: null,
					车牌号码: '',
					名称: '',
					车型: '',
					车辆类型: '',
					使用性质: '',
					车辆所有人: '',
					车辆分类: '',
					品牌型号: '',
					发动机排量: '',
					整备质量: '',
					总质量: '',
					核定载人数: '',
					车身颜色: '',
					发动机号码: '',
					车辆识别代号: '',
					登记证书号: '',
					行驶证注册日期: '',
					行驶证发证日期: '',
					类型: '',
					类别: '',
					单位: '',
					保留车牌: '',
					驾驶员: '',
					驾驶员手机: '',
					轮胎规格: '',
					卖出日期: '',
					卖出价格: '',
					驾驶证类型: '',
					备注: '',
					旧车牌: '',
					交强险开始日期: null,
					交强险结束日期: null,
					商业险开始日期: null,
					商业险结束日期: null,
					购买价格: 0,
					购买日期: null,
					使用年限: '',
					年检时间: null,
					附件网址: [],
					油卡编号: '',
					送车时间: null,
					承运险开始日期: null,
					承运险结束日期: null,
				},
				编辑表单验证: {
					车牌号码: [{
						required: true,
						message: '请输入车牌号码',
						trigger: 'blur'
					}],
					名称: [{
						required: true,
						message: '请输入名称',
						trigger: 'blur'
					}],
					车型: [{
						required: true,
						message: '请输入车型',
						trigger: 'blur'
					}],
					车辆类型: [{
						required: true,
						message: '请输入车辆类型',
						trigger: 'blur'
					}],
					使用性质: [{
						required: true,
						message: '请输入使用性质',
						trigger: 'blur'
					}],
					车辆所有人: [{
						required: true,
						message: '请输入车辆所有人',
						trigger: 'blur'
					}],
					车辆分类: [{
						required: true,
						message: '请输入车辆分类',
						trigger: 'blur'
					}],
					品牌型号: [{
						required: true,
						message: '请输入品牌型号',
						trigger: 'blur'
					}],
					发动机排量: [{
						required: true,
						message: '请输入发动机排量',
						trigger: 'blur'
					}],
					整备质量: [{
						required: true,
						message: '请输入整备质量',
						trigger: 'blur'
					}],
					总质量: [{
						required: true,
						message: '请输入总质量',
						trigger: 'blur'
					}],
					核定载人数: [{
						required: true,
						message: '请输入核定载人数',
						trigger: 'blur'
					}],
					车身颜色: [{
						required: true,
						message: '请输入车身颜色',
						trigger: 'blur'
					}],
					发动机号码: [{
						required: true,
						message: '请输入发动机号码',
						trigger: 'blur'
					}],
					车辆识别代号: [{
						required: true,
						message: '请输入车辆识别代号',
						trigger: 'blur'
					}],
					登记证书号: [{
						required: true,
						message: '请输入登记证书号',
						trigger: 'blur'
					}],
					行驶证注册日期: [{
						required: true,
						message: '请输入行驶证注册日期',
						trigger: 'blur'
					}],
					行驶证发证日期: [{
						required: true,
						message: '请输入行驶证发证日期',
						trigger: 'blur'
					}],
					类型: [{
						required: true,
						message: '请输入类型',
						trigger: 'blur'
					}],
					类别: [{
						required: true,
						message: '请输入类别',
						trigger: 'blur'
					}],
					单位: [{
						required: true,
						message: '请输入单位',
						trigger: 'blur'
					}],
					保留车牌: [{
						required: true,
						message: '请输入保留车牌',
						trigger: 'blur'
					}],
				},
				部门职务列表: [],
				车辆分类2列表: [],
				车辆类别列表: [],
				油卡列表: [],

				购买价格权限: '',

				整备费: [],
				整备费统计: {},
			};
		},
		created: function() {
			this.获取默认参数();
			this.查询信息();
		},
		methods: {
			获取默认参数() {
				this.$http.post('get/cheliangxinxi/list').then(返回数据 => {
					this.购买价格权限 = 返回数据.购买价格权限;
					this.车辆分类2列表 = 返回数据.车辆分类2列表;
					this.车辆类别列表 = 返回数据.车辆类别列表;
					this.油卡列表 = 返回数据.油卡列表;
				});
			},
			uploadremove(文件, 文件列表) {
				console.log(文件);
				console.log(文件列表);
				let 文件列表长度 = 文件列表.length;
				this.编辑表单.附件网址 = [];
				if (文件列表长度 > 0) {
					for (let i = 0; i < 文件列表长度; i++) {
						if (文件列表[i].response) {
							this.编辑表单.附件网址.push({
								id: 文件列表[i].response.文件编号,
								name: 文件列表[i].response.文件名称,
								url: 文件列表[i].response.文件网址
							});
						} else {
							this.编辑表单.附件网址.push({
								id: 文件列表[i].id,
								name: 文件列表[i].name,
								url: 文件列表[i].url
							});
						}
					}
				}

				console.log(this.编辑表单);
				// if (文件.response) {
				//   文件网址 = 文件.response.文件网址;
				// } else {
				//   文件网址 = 文件.url;
				// }
				// this.$http
				//   .post('gg/shangchuan/del', {
				//     文件网址: 文件网址
				//   })
				//   .then(response => {
				//     this.$message.success(response.信息);
				//   });
				// console.log(文件网址);

			},
			uploaderror(err, file, fileList) {
				this.$message.error('该文件无法识别，可能文件已损坏');
				console.log(err);
				console.log(file);
				console.log(fileList);
			},
			uploadsuccess(response, file, fileList) {
				console.log(response);
				if (response.代码 == '成功') {
					// this.文件列表.push({
					// 	name: response.文件名称,
					// 	url: response.文件网址
					// });
					if (!this.编辑表单.附件网址) {
						this.编辑表单.附件网址 = [];
					}

					this.编辑表单.附件网址.push({
						id: response.文件编号,
						name: response.文件名称,
						url: response.文件网址
					});

					// this.编辑表单.附件网址 += response.文件网址 + '；';

					console.log(file);
					console.log(fileList);
					console.log(this.文件列表);
				} else {
					this.$message.error(response.信息);
				}
			},
			onfile(文件) {
				let fuwuqi = this.gg.fuwuqi;
				console.log(fuwuqi);
				var a = document.createElement('a');
				a.target = '_blank';
				var 文件网址 = ""; // eslint-disable-line no-unused-vars
				//a.href=this.editBrand.contract;
				if (文件.response) {
					文件网址 = fuwuqi + "/" + 文件.response.文件网址;
				} else {
					文件网址 = fuwuqi + "/" + 文件.url;
				}
				a.href = 文件网址;
				a.download = 文件.name;
				a.click();
				console.log(文件);
			},
			查询信息() {
				this.$http
					.post('cheliang/clxx/get', {
						车辆编号: this.cheliangbianhao
					})
					.then(返回数据 => {
						this.编辑表单 = 返回数据.车辆信息;
						this.整备费 = 返回数据.整备费;
						this.整备费统计 = 返回数据.整备费统计;
						//console.log(返回数据);
						// this.编辑表单.车牌号码 = 返回数据.车辆信息.车牌号码;
						// this.编辑表单.名称 = 返回数据.车辆信息.名称;
						// this.编辑表单.车型 = 返回数据.车辆信息.车型;
						// this.编辑表单.车辆类型 = 返回数据.车辆信息.车辆类型;
						// this.编辑表单.使用性质 = 返回数据.车辆信息.使用性质;
						// this.编辑表单.车辆所有人 = 返回数据.车辆信息.车辆所有人;
						// this.编辑表单.车辆分类 = 返回数据.车辆信息.车辆分类;
						// this.编辑表单.品牌型号 = 返回数据.车辆信息.品牌型号;
						// this.编辑表单.发动机排量 = 返回数据.车辆信息.发动机排量;
						// this.编辑表单.整备质量 = 返回数据.车辆信息.整备质量;
						// this.编辑表单.总质量 = 返回数据.车辆信息.总质量;
						// this.编辑表单.核定载人数 = 返回数据.车辆信息.核定载人数;
						// this.编辑表单.车身颜色 = 返回数据.车辆信息.车身颜色;
						// this.编辑表单.发动机号码 = 返回数据.车辆信息.发动机号码;
						// this.编辑表单.车辆识别代号 = 返回数据.车辆信息.车辆识别代号;
						// this.编辑表单.登记证书号 = 返回数据.车辆信息.登记证书号;
						// this.编辑表单.行驶证注册日期 = 返回数据.车辆信息.行驶证注册日期;
						// this.编辑表单.行驶证发证日期 = 返回数据.车辆信息.行驶证发证日期;
						// this.编辑表单.类型 = 返回数据.车辆信息.类型;
						// this.编辑表单.类别 = 返回数据.车辆信息.类别;
						// this.编辑表单.单位 = 返回数据.车辆信息.单位;
						// this.编辑表单.保留车牌 = 返回数据.车辆信息.保留车牌;
						// this.编辑表单.驾驶员 = 返回数据.车辆信息.驾驶员;
						// this.编辑表单.驾驶员手机 = 返回数据.车辆信息.驾驶员手机;
						// this.编辑表单.轮胎规格 = 返回数据.车辆信息.轮胎规格;
						// this.编辑表单.卖出日期 = 返回数据.车辆信息.卖出日期;
						// this.编辑表单.卖出价格 = 返回数据.车辆信息.卖出价格;
						// this.编辑表单.驾驶证类型 = 返回数据.车辆信息.驾驶证类型;
						// this.编辑表单.备注 = 返回数据.车辆信息.备注;
						// this.编辑表单.附件网址 = 返回数据.车辆信息.附件网址;
					});
			},
			关闭编辑页面() {
				//console.log(111);
				this.$emit('close', false);
			},
			保存() {
				console.log(this.编辑表单);
				this.$refs['编辑表单'].validate(valid => {
					if (valid) {
						this.$http
							.post('cheliang/clxx/edit', this.编辑表单)
							.then(response => {
								this.$message.success(response.信息);
								this.$emit('shuaxin_data');
								this.关闭编辑页面();
							});
					} else {
						//console.log(this.订单表单);
						console.log('下单验证不通过，请检查下单信息是否正确!');
						return false;
					}
				});
			},

		}
	};
</script>
